import * as React from 'react';
import { Link } from 'react-router-dom';
import WetnotesLogo from '../WetnotesLogo';

interface IProps {
  onClick?: () => void;
}

const HeaderLogo = ({onClick}: IProps) => {
  return (
    <div className="header--logo">
      {onClick ? (
        <button className="header--link" onClick={onClick}>
          <WetnotesLogo />
        </button>
      )
      : (
        <Link className="header--link" to="/app">
          <WetnotesLogo />
        </Link>
      )}
    </div>
  );
};

export default HeaderLogo;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/HeaderLogo/HeaderLogo.tsx